export function agentReducer(state = {
    agents : null,
    rzcommercialList : [],
},{
    type,
    payload
}){
    switch(type){
        case "GET_AGENTS":
            let list = Object.assign({}, state) 
            list.agents = payload
            return list

        case "GET_AGENT_RZ_COMMERCIAL_LIST":
            let list2 = Object.assign({}, state) 
            list2.rzcommercialList = payload
            return list2

        case "UPDATE_AGENT":
            let list3 = Object.assign({}, state)
            list3.agents[payload.id].other = payload.data
            return list3
        case "UPDATE_AGENTS_STOCKS":
            let list4 = Object.assign({}, state)
            payload.forEach( stock => {
                if( !list4.agents[stock.commercial_id] ){
                    list4.agents[stock.commercial_id].stocks = []
                }
                list4.agents[stock.commercial_id].stocks.push(stock)
            })
            return list4
        default:
            return state;
    }
}


// -------------------- ACTIONS

export function getRZCommercialList(commercialID){
    return async function (dispatch){
        try {
            const req = await fetch('/agent/rz/getcommercial/list?commercialID='+commercialID,{
                method:'GET',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                },
                credentials: 'same-origin',
            })
            let list = await req.json();
            console.log('getRZCommercialList res : ', list);
            if(!list.error){
                dispatch({
                    type: "GET_AGENT_RZ_COMMERCIAL_LIST",
                    payload: list.commercialList || []
                })
            }
        } catch (error) {
            console.log("[ERROR] getRZCommercialList : ", error);
        }
    }
}